<template>
    <div>
        <Login :product_name="'DigiAdmin'" />
    </div>
</template>

<script>
import {Login} from '@digicollect_front_end/digi-fe-library'
// import Login from "./LoginNewDesign.vue";
export default {
    data(){
        return {
            // product_name: 'digiCloud'
        }
    },
    components: {
        Login
    },
    methods: {
        
    },
    computed: {

    },
}
</script>